import { render } from "./criteria-modal.vue?vue&type=template&id=12d61a45&ts=true"
import script from "./criteria-modal.vue?vue&type=script&lang=ts"
export * from "./criteria-modal.vue?vue&type=script&lang=ts"

import "./criteria-modal.vue?vue&type=style&index=0&id=12d61a45&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__